import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Moment } from 'moment'

import { ByBenefitTable } from './ByBenefitTable'
import { ByLevelTable } from './ByLevelTable'
import { ParkingHoursCharts } from './ParkingHoursCharts'

interface Props {
  startDate: Moment
  endDate: Moment
}

const ParkingBenefits: React.FC<Props> = ({ startDate, endDate }) => (
  <Grid container spacing={3} item xs={12}>
    <ByBenefitTable startDate={startDate} endDate={endDate} />
    <ByLevelTable startDate={startDate} endDate={endDate} />
    <ParkingHoursCharts startDate={startDate} endDate={endDate} />
  </Grid>
)

export { ParkingBenefits }
